import * as React from 'react';
import { VirtualList } from '../virtual-list';
import ListContext from "./context/ListContext";
var VirtualListWrapper = function VirtualListWrapper(props) {
  var height = props.height,
    itemHeight = props.itemHeight,
    itemKey = props.itemKey,
    renderList = props.renderList;
  var _React$useContext = React.useContext(ListContext),
    listStore = _React$useContext.listStore;
  return /*#__PURE__*/React.createElement(VirtualList, {
    id: "list",
    height: height,
    itemHeight: itemHeight,
    itemKey: itemKey,
    style: {
      boxSizing: 'border-box'
    },
    data: listStore.data
  }, renderList);
};
export default VirtualListWrapper;